import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface MoveNavigationItemOptions {
	id: string;
	offset: number;
}

const moveNavigationItem = async ({
	id,
	offset
}: MoveNavigationItemOptions) => {
	const url = `/homepage/admin/mobilenavigation/${id}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMoveNavigationItem = () => {
	const queryClient = useQueryClient();

	const onSettled = () => {
		queryClient.invalidateQueries(["navigation-items"]);
	};

	const mutation = useMutation(moveNavigationItem, {
		onSettled
	});

	return mutation;
};

export default useMoveNavigationItem;
